import { render, staticRenderFns } from "./SingleNews.vue?vue&type=template&id=2c4bfb00&scoped=true&"
import script from "./SingleNews.vue?vue&type=script&lang=js&"
export * from "./SingleNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4bfb00",
  null
  
)

export default component.exports